var Glyphicon = require("components/utility/icons/Glyphicon");

require("utility/help_section_link.scss");

var HelpSectionLink = function(props) {
	var className = props.className || "";
	className += " helpSectionLink hideOnPrint";
	var link = "https://whooosreading.zendesk.com/hc/en-us/articles/" + props.linkSuffix;
	var linkText = "Learn more about " + props.featureName;

	if (props.iconOnly) {
		var linkContent = (
			<Glyphicon icon="info-sign" dataTip={ linkText } />
		);
	} else {
		var linkContent = (
			<span>
				<Glyphicon icon="info-sign" />
				{ " " }
				{ linkText }
			</span>
		);
	}

	return (
		<span className={ className }>
			<a href={ link } target="_blank">
				{ linkContent }
			</a>
		</span>
	);
};

HelpSectionLink.propTypes = StrictPropTypes({
	// name of feature that is linked
	featureName: PropTypes.string.isRequired,

	// help section article suffix from zendesk, e.g. "235179488-Add-Delete-Class-or-Student"
	linkSuffix: PropTypes.string.isRequired,

	// will display only the icon if set to true, default to icon and text
	iconOnly: PropTypes.bool,

	// optional class
	className: PropTypes.string,

});

module.exports = HelpSectionLink;



// WEBPACK FOOTER //
// ./modules/components/utility/HelpSectionLink.js